module.exports = ".personal-task tbody tr td, .personal-task_ tbody tr td {\r\n    padding: 0!important;\r\n}"